import {Component, Input, TemplateRef} from '@angular/core';
import {AbstractControl, FormControl, UntypedFormArray} from '@angular/forms';

@Component({
  selector: 'app-array-field',
  templateUrl: './array-field.component.html',
  styleUrl: './array-field.component.css',
  standalone: false,
})
export class ArrayFieldComponent {
  @Input({required: true}) formArray!: UntypedFormArray;
  @Input({required: true}) formTemplate!: TemplateRef<{
    $implicit: AbstractControl,
    $index: number,
    $count: number,
    $first: boolean,
    $last: boolean,
    $even: boolean,
    $odd: boolean
  }>;

  @Input() addButtonLabel?: string;
  @Input() emptyError?: string;
  @Input() newControl: () => AbstractControl = () => new FormControl('');

  add() {
    this.formArray.push(this.newControl());
  }

  delete(index: number) {
    this.formArray.removeAt(index);
  }
}
